const popovers = document.querySelectorAll('[data-bs-toggle="popover"]');

popovers.forEach(function(popoverEl) {
    new bootstrap.Popover(popoverEl, {
        html: true
    });
});
jQuery(document).ready(function ($) {
  
	$('.socials_slider').slick({
	  slidesToShow: 4,
	  arrows:false,
	  autoplay:false,
	  responsive: [
	    {
	      breakpoint: 959,
	      settings: {
	        slidesToShow: 3
	      }
	    },
	    {
	      breakpoint: 575,
	      settings: {
	        slidesToShow: 2,
	      }
	    }
	  ]
	});

    $(".color-swatch").click(function(){
      var title = $(this).data("title");
      var color = $(this).data("color");
      $('span.selected-variant-name').text(title);
      $('span.selected-variant-name').removeClass().addClass('selected-variant-name');
      $('span.selected-variant-name').addClass(color);
      
    })
})